/**
 * TPL Gallery Dots — motion.dev "Carousel: scaling pagination dots" port.
 * 2026-10-27 (owner): drawn as the La Siesta segment bar (grey track, the
 * current photo's segment fills black) and the gallery steps on by itself
 * every 6 s with a slow glide. Auto-step pauses for 9 s after any touch,
 * off screen, with the tab hidden, while a video plays, with the zoom modal
 * open, and never runs under reduced motion.
 * Mobile PDP gallery: one dot per visible slide under the slider. Dots grow and
 * darken with proximity to the slide under the viewport centre while you drag,
 * so the position reads continuously instead of stepping. Tapping a dot
 * scrolls to that slide. Desktop keeps Dawn's layout (dots hidden by CSS).
 */
(function () {
  'use strict';

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Continuous slide index for a scroll offset given slide start offsets. Pure. */
  function positionFor(scrollLeft, starts) {
    if (!starts.length) return 0;
    if (scrollLeft <= starts[0]) return 0;
    for (var i = 0; i < starts.length - 1; i++) {
      var a = starts[i], b = starts[i + 1];
      if (scrollLeft >= a && scrollLeft <= b) return b === a ? i : i + (scrollLeft - a) / (b - a);
    }
    return starts.length - 1;
  }

  function init(slider) {
    if (slider.dataset.tplGdots === '1') return;
    var list = slider.querySelector('.product__media-list');
    if (!list) return;
    var slides = Array.prototype.filter.call(list.children, function (li) {
      return li.tagName === 'LI' && window.getComputedStyle(li).display !== 'none';
    });
    if (slides.length < 2) return;
    slider.dataset.tplGdots = '1';
    slider.classList.add('has-gdots');

    var dots = document.createElement('div');
    dots.className = 'tpl-gdots';
    dots.setAttribute('aria-label', 'Gallery position');
    slides.forEach(function (li, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tpl-gdots__dot';
      b.setAttribute('aria-label', 'Image ' + (i + 1) + ' of ' + slides.length);
      b.addEventListener('click', function () {
        list.scrollTo({ left: li.offsetLeft - slides[0].offsetLeft, behavior: reducedMotion() ? 'auto' : 'smooth' });
      });
      dots.appendChild(b);
    });
    /* Sit where Dawn's arrows were so nothing collides with the floating
       "See it on your wall" pill over the image edge; CSS hides the arrows. */
    var buttons = slider.querySelector('.slider-buttons');
    if (buttons) buttons.appendChild(dots); else list.insertAdjacentElement('afterend', dots);
    /* 2026-10-27: on phones the details panel starts right where the photo
       ends and covered this row, so the bar was never seen. Move it to the
       top of the details panel: it then sits directly under the photo, on
       white, like the La Siesta gallery bar. */
    var info = slider.closest('.product') && slider.closest('.product').querySelector('.product__info-wrapper');
    var mq = window.matchMedia('(max-width: 749px)');
    function place() {
      if (mq.matches && info) {
        if (dots.parentElement !== info) { info.insertBefore(dots, info.firstChild); dots.classList.add('tpl-gdots--under'); }
        slider.classList.add('tpl-gdots-moved');
      } else if (dots.classList.contains('tpl-gdots--under')) {
        dots.classList.remove('tpl-gdots--under');
        slider.classList.remove('tpl-gdots-moved');
        if (buttons) buttons.appendChild(dots); else list.insertAdjacentElement('afterend', dots);
      }
    }
    place();
    if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
    var dotEls = Array.prototype.slice.call(dots.children);

    var ticking = false;
    function paint() {
      ticking = false;
      var starts = slides.map(function (li) { return li.offsetLeft - slides[0].offsetLeft; });
      var p = positionFor(list.scrollLeft, starts);
      var nearest = Math.round(p);
      dotEls.forEach(function (d, i) {
        var k = Math.max(0, 1 - Math.abs(i - p));
        d.style.setProperty('--k', k.toFixed(3));
        if (i === nearest) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
    }
    function onScroll() {
      if (!gliding) lastUser = Date.now();
      if (ticking) return; ticking = true; requestAnimationFrame(paint);
    }
    list.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    paint();

    /* ── slow auto-step ── */
    var AUTO_MS = 6000, IDLE_MS = 9000, GLIDE_MS = 1200;
    var lastUser = 0, lastStep = Date.now(), gliding = false, inView = false;
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (ev) {
      list.addEventListener(ev, function () { lastUser = Date.now(); }, { passive: true });
    });
    dots.addEventListener('click', function () { lastUser = Date.now(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { inView = es[0].isIntersecting; }, { threshold: 0.5 }).observe(list);
    }
    function ease(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function glideTo(x) {
      var from = list.scrollLeft, t0 = performance.now();
      gliding = true;
      var snap = list.style.scrollSnapType;
      list.style.scrollSnapType = 'none';
      (function step(now) {
        var t = Math.min(1, (now - t0) / GLIDE_MS);
        list.scrollLeft = from + (x - from) * ease(t);
        if (t < 1) { requestAnimationFrame(step); return; }
        list.style.scrollSnapType = snap;
        setTimeout(function () { gliding = false; }, 80);
      })(t0);
    }
    function current() {
      var starts = slides.map(function (li) { return li.offsetLeft - slides[0].offsetLeft; });
      return { starts: starts, i: Math.round(positionFor(list.scrollLeft, starts)) };
    }
    function blocked(i) {
      if (reducedMotion() || document.hidden || !inView || gliding) return true;
      if (list.scrollWidth <= list.clientWidth + 4) return true;   /* desktop: not a slider */
      if (Date.now() - lastUser < IDLE_MS) return true;
      if (document.querySelector('product-modal[open], .product-media-modal[open]')) return true;
      var v = slides[i] && slides[i].querySelector('video');
      if (v && !v.paused) return true;
      return false;
    }
    setInterval(function () {
      if (Date.now() - lastStep < AUTO_MS) return;
      var c = current();
      if (blocked(c.i)) { lastStep = Date.now() - AUTO_MS + 1000; return; }
      lastStep = Date.now();
      glideTo(c.starts[(c.i + 1) % c.starts.length]);
    }, 500);
  }

  /* The gallery can be (re)built after this deferred script runs, so boot is
     idempotent and fires at parse end, DOMContentLoaded, load and once more late. */
  function boot() { document.querySelectorAll('slider-component').forEach(init); }
  boot();
  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  setTimeout(boot, 1500);

  window.TPLGalleryDots = { init: init, positionFor: positionFor };
})();
